
function formatName (firstName:string,lastName:string): string  {
let fullName = "";
if(firstName != undefined)
    fullName = firstName;
if(lastName != undefined)
    fullName = fullName +" "+ lastName
return fullName != "" ? fullName.trim() : "N/A";
}
export default formatName;